import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import SEO from '../../common/SEO';
import GoogleMaps from '../../components/GoogleMaps';
import ServicesNavigationFooter from '../../components/ServicesNavigationFooter';
import RelatedTopics from '../../components/RelatedTopics';
import * as FiIcons from 'react-icons/fi';

const {FiArrowLeft,FiCheckCircle,FiShield,FiAlertTriangle,FiCloud,FiThermometer,FiMapPin,FiXCircle,FiCheck,FiInfo,FiHelpCircle,FiHome,FiFlame,FiPhone,FiChevronDown,FiChevronUp}=FiIcons;

function SheepWoolProsCons() {
  // Kombiniertes Schema für maximale SEO-Power (Article + FAQ + LocalBusiness)
  const combinedSchema={
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "headline": "Schafwolle Dämmung – Vorteile & Nachteile im Detail | MK-AUSBAU",
        "alternativeHeadline": "Pro & Contra: Lohnt sich Schafwolle als Dämmstoff?",
        "image": "https://mx.ausbau.nrw/img/Daemmtechnik_xl.jpg",
        "author": {
          "@type": "Person",
          "name": "Maxim Kelm",
          "jobTitle": "Geschäftsführer MK-AUSBAU",
          "url": "https://ausbau.nrw/ueber"
        },
        "publisher": {
          "@type": "Organization",
          "name": "MK-AUSBAU",
          "logo": {
            "@type": "ImageObject",
            "url": "https://ausbau.nrw/logo-icon.svg"
          }
        },
        "datePublished": "2026-05-03",
        "description": "Detaillierter Vergleich: Alle Vorteile und Nachteile der Schafwolle Dämmung. Kosten,Brandschutz,Motten & Dämmwerte im Experten-Check.",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://ausbau.nrw/blog/schafwolle-daemmung-vorteile-nachteile"
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Was sind die wichtigsten Vorteile der Schafswolle Dämmung?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Die größten Vorteile der Schafswolle Dämmung sind ihre hervorragende Wärmedämmung,die natürliche Feuchtigkeitsregulierung,der gute Schallschutz sowie die nachhaltige Herkunft. Zusätzlich verbessert Schafwolle das Raumklima,da sie Schadstoffe aus der Luft binden kann."
            }
          },
          {
            "@type": "Question",
            "name": "Welche Nachteile hat Schafswolle als Dämmstoff?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Zu den Nachteilen zählen die höheren Kosten im Vergleich zu herkömmlichen Dämmstoffen,die notwendige Behandlung gegen Schädlinge sowie ein geringerer Brandschutz (B2) im Vergleich zu mineralischen Dämmstoffen (A1)."
            }
          },
          {
            "@type": "Question",
            "name": "Ist Schafswolle Dämmung für Altbauten geeignet?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja,Schafswolle eignet sich besonders gut für Altbauten,da sie Feuchtigkeit aufnehmen und wieder abgeben kann,ohne ihre Dämmwirkung zu verlieren. Gerade bei Sanierungen in Heinsberg,Aachen oder Mönchengladbach ist sie eine beliebte Lösung für gesundes Wohnklima."
            }
          },
          {
            "@type": "Question",
            "name": "Kann Schafswolle schimmeln?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Schafswolle selbst ist von Natur aus schimmelresistent,da sie Feuchtigkeit reguliert. Schimmel entsteht meist nur bei dauerhafter Nässe durch Bauschäden oder falsche Verarbeitung. Eine fachgerechte Planung ist daher entscheidend."
            }
          },
          {
            "@type": "Question",
            "name": "Ist Schafswolle Dämmung brandsicher?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Schafswolle gilt als schwer entflammbar,jedoch zur Baustoffklasse B2 (normal entflammbar). In Wohngebäuden in NRW können je nach Gebäudeklasse zusätzliche Brandschutzmaßnahmen erforderlich sein."
            }
          },
          {
            "@type": "Question",
            "name": "Wie lange hält eine Schafswolle Dämmung?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Bei richtiger Verarbeitung und Schutz vor Motten kann Schafswolle mehrere Jahrzehnte halten. In der Praxis sind 40–50 Jahre Lebensdauer realistisch."
            }
          },
          {
            "@type": "Question",
            "name": "Ist Schafswolle für Allergiker geeignet?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja,Schafswolle ist haut- und atemwegsfreundlich und gibt keine reizenden Fasern ab wie Mineralwolle. Sie kann sogar Schadstoffe wie Formaldehyd aus der Raumluft filtern (Keratin)."
            }
          }
        ]
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://ausbau.nrw/#business",
        "name": "MK-AUSBAU",
        "url": "https://ausbau.nrw",
        "description": "MK-AUSBAU ist Ihr Partner für Ausbau,Sanierung und Dämmung (u. a. Schafswolle Dämmung) im Umkreis von Heinsberg und NRW.",
        "telephone": "+4924528607038",
        "email": "info@ausbau.nrw",
        "image": "https://ausbau.nrw/logo-icon.svg",
        "priceRange": "€€",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Am Diebsweg 17",
          "postalCode": "52525",
          "addressLocality": "Heinsberg",
          "addressRegion": "NRW",
          "addressCountry": "DE"
        },
        "areaServed": [
          {"@type": "City","name": "Heinsberg"},
          {"@type": "City","name": "Erkelenz"},
          {"@type": "City","name": "Geilenkirchen"},
          {"@type": "City","name": "Hückelhoven"},
          {"@type": "City","name": "Wegberg"},
          {"@type": "City","name": "Aachen"},
          {"@type": "City","name": "Mönchengladbach"},
          {"@type": "City","name": "Düsseldorf"}
        ],
        "makesOffer": [
          {
            "@type": "Offer",
            "name": "Beratung & Einbau Schafswolle Dämmung",
            "availability": "https://schema.org/InStock",
            "url": "https://ausbau.nrw/kontakt"
          }
        ]
      }
    ]
  };

  const faqs=[
    {
      question: "Was sind die wichtigsten Vorteile der Schafswolle Dämmung?",
      answer: "Die größten Vorteile sind die hervorragende Wärmedämmung,die natürliche Feuchtigkeitsregulierung (bis zu 33% des Eigengewichts),der gute Schallschutz sowie die nachhaltige Herkunft. Einzigartig ist die Fähigkeit,Schadstoffe wie Formaldehyd aus der Raumluft zu binden."
    },
    {
      question: "Welche Nachteile hat Schafswolle als Dämmstoff?",
      answer: "Hauptnachteile sind die höheren Kosten (Faktor 2-3 zu Mineralwolle),die notwendige Behandlung gegen Mottenfraß sowie die Baustoffklasse B2 (normal entflammbar),was den Einsatz in manchen gewerblichen oder hohen Gebäuden einschränkt."
    },
    {
      question: "Ist Schafswolle Dämmung für Altbauten geeignet?",
      answer: "Ja,exzellent sogar. Da sie Feuchtigkeit puffern kann,verzeiht sie bauphysikalische Schwankungen im Altbau oft besser als synthetische Stoffe. Gerade bei Fachwerkhäusern oder Innendämmungen in Heinsberg und Umgebung ist sie sehr beliebt."
    },
    {
      question: "Kann Schafswolle schimmeln?",
      answer: "Die Faser selbst ist eiweißbasiert und bei dauerhafter Nässe theoretisch anfällig. Durch die natürliche Feuchteregulierung ist sie in der Praxis aber sehr robust. Schimmel entsteht meist nur bei groben Baufehlern (z.B. undichtes Dach)."
    },
    {
      question: "Wird Schafswolle gegen Motten behandelt?",
      answer: "Ja,das ist zwingend notwendig. Hochwertige Dämmstoffe werden meist mit Borsalz oder dem LANISOL-Verfahren (ohne Biozide) dauerhaft gegen Mottenfraß geschützt. Wir bei MK-AUSBAU achten strikt auf zertifizierte Ware."
    },
    {
      question: "Ist Schafswolle Dämmung teurer als Mineralwolle?",
      answer: "Ja,die Materialkosten sind höher. Langfristig relativiert sich dies oft durch das bessere Raumklima und die Langlebigkeit. Für Budget-Sanierungen ist sie meist nicht die erste Wahl,für Qualitäts-Wohnen aber unschlagbar."
    }
  ];

  return (
    <div className="py-20 bg-white">
      <SEO 
        title="Schafwolle Dämmung: Vorteile & Nachteile | Experten-Check" 
        description="Lohnt sich Schafwolle? 🐑 Alle Vor- und Nachteile im ehrlichen Vergleich. Kosten,Dämmleistung & Risiken für Bauherren in NRW." 
        keywords="Schafwolle Dämmung Vorteile Nachteile,Schafwolldämmung Pro Contra,Kosten Schafwolle Dämmung,Motten Schafwolle,Brandschutz Schafwolle" 
        schema={combinedSchema} 
        canonical="/blog/schafwolle-daemmung-vorteile-nachteile" 
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center text-mk-teal-600 hover:text-mk-teal-700 font-bold mb-8 transition-colors group">
          <SafeIcon icon={FiArrowLeft} className="mr-2 w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          Zurück zur Übersicht
        </Link>
        
        <motion.article 
          initial={{opacity: 0,y: 20}} 
          animate={{opacity: 1,y: 0}} 
          className="prose prose-lg prose-mk max-w-none"
        >
          {/* Header */}
          <header className="mb-12">
            <div className="flex items-center space-x-3 text-mk-teal-600 font-bold uppercase tracking-wider text-sm mb-4">
              <SafeIcon icon={FiCloud} />
              <span>Material-Vergleich</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              🐑 Schafwolle Dämmung – Vorteile & Nachteile im Detail
            </h1>
            
            <div className="flex items-center space-x-4 text-gray-500 text-sm border-y border-gray-100 py-4">
              <span className="flex items-center"><SafeIcon icon={FiShield} className="mr-1" /> Analyse</span>
              <span className="flex items-center"><SafeIcon icon={FiInfo} className="mr-1" /> MK-AUSBAU &gt; ausbau.nrw</span>
            </div>
          </header>

          <div className="lead text-xl text-gray-600 leading-relaxed mb-12">
            Wer natürlich dämmen will,landet schnell bei Schafwolle. Doch ist der organische Dämmstoff wirklich die beste Wahl für dein Haus? Wir beleuchten die <strong>Vorteile und Nachteile</strong> schonungslos – von der Feuchtigkeitsregulierung bis zur Mottengefahr.
          </div>

          {/* Vorteile Section */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6 flex items-center">
            <SafeIcon icon={FiCheckCircle} className="mr-3 text-mk-teal-600" />
            Die Vorteile: Warum Schafwolle begeistert
          </h2>
          
          <div className="space-y-6 mb-12">
            {[
              {
                title: "Luftreinigung (Keratin)",
                text: "Einzigartig: Schafwolle kann Schadstoffe wie Formaldehyd aus der Raumluft binden und dauerhaft abbauen. Perfekt für Allergiker.",
                icon: FiShield
              },
              {
                title: "Feuchtigkeits-Management",
                text: "Die Faser kann bis zu 33% ihres Eigengewichts an Feuchtigkeit aufnehmen,ohne an Dämmwirkung zu verlieren. Das schützt die Bausubstanz.",
                icon: FiCloud
              },
              {
                title: "Hitzeschutz im Sommer",
                text: "Durch die hohe Speichermasse bietet Schafwolle einen besseren sommerlichen Hitzeschutz als leichte Mineralwolle.",
                icon: FiThermometer
              },
              {
                title: "Nachwachsend & Regional",
                text: "Schafwolle ist ein Abfallprodukt der Landschaftspflege. Kurze Wege in NRW und Eifel machen sie ökologisch top.",
                icon: FiCheck
              }
            ].map((item,idx)=> (
              <div key={idx} className="bg-mk-teal-50 p-6 rounded-xl border border-mk-teal-100 flex gap-4">
                <SafeIcon icon={item.icon} className="text-mk-teal-600 w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-bold text-mk-teal-900 mt-0 mb-2">{item.title}</h3>
                  <p className="text-mk-teal-800 text-sm m-0">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Nachteile Section */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6 flex items-center">
            <SafeIcon icon={FiAlertTriangle} className="mr-3 text-mk-red-600" />
            Die Nachteile: Wo die Grenzen liegen
          </h2>
          
          <div className="space-y-6 mb-12">
            {[
              {
                title: "Hoher Preis",
                text: "Schafwolle ist deutlich teurer als Mineralwolle oder Zellulose. Faktor 2 bis 3 bei den Materialkosten ist realistisch.",
                icon: FiXCircle
              },
              {
                title: "Schädlingsrisiko (Motten)",
                text: "Ohne Ausrüstung (z.B. mit Borsalz oder LANISOL) wird Wolle von Kleidermotten gefressen. Ein dauerhafter Schutz ist Pflicht!",
                icon: FiAlertTriangle
              },
              {
                title: "Brandschutz (B2)",
                text: "Schafwolle ist normal entflammbar (B2). Für Gebäude mit hohen Brandschutzauflagen (Mehrfamilienhäuser) oft nur eingeschränkt nutzbar.",
                icon: FiFlame
              },
              {
                title: "Geruch",
                text: "Frische Schafwolldämmung kann in den ersten Wochen einen leichten Eigengeruch ('Schafstall') haben,der aber verfliegt.",
                icon: FiInfo
              }
            ].map((item,idx)=> (
              <div key={idx} className="bg-mk-red-50 p-6 rounded-xl border border-mk-red-100 flex gap-4">
                <SafeIcon icon={item.icon} className="text-mk-red-600 w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-lg font-bold text-mk-red-900 mt-0 mb-2">{item.title}</h3>
                  <p className="text-mk-red-800 text-sm m-0">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Comparison Table */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Direkter Vergleich</h2>
          
          <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm mb-12">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-100 text-gray-900 font-bold">
                <tr>
                  <th className="px-6 py-4">Eigenschaft</th>
                  <th className="px-6 py-4">Schafwolle</th>
                  <th className="px-6 py-4">Mineralwolle</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="px-6 py-4 font-medium">Preis</td>
                  <td className="px-6 py-4 text-mk-red-600">Hoch (€€€)</td>
                  <td className="px-6 py-4 text-green-600">Niedrig (€)</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-medium">Feuchte-Regulierung</td>
                  <td className="px-6 py-4 text-green-600">Exzellent</td>
                  <td className="px-6 py-4 text-gray-600">Gering</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-medium">Luftreinigung</td>
                  <td className="px-6 py-4 text-green-600">Ja (Schadstoffe)</td>
                  <td className="px-6 py-4 text-gray-600">Nein</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-medium">Brandschutz</td>
                  <td className="px-6 py-4 text-gray-600">B2 (Normal)</td>
                  <td className="px-6 py-4 text-green-600">A1 (Nicht brennbar)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* FAQ Section */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-8 flex items-center">
            <SafeIcon icon={FiHelpCircle} className="mr-3 text-mk-teal-600" />
            Häufige Fragen zur Schafswolle Dämmung (FAQ)
          </h2>
          
          <div className="grid grid-cols-1 gap-6 mb-16">
            {faqs.map((faq,idx)=> (
              <div key={idx} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-mk-teal-200 transition-colors">
                <h3 className="font-bold text-gray-900 text-lg mb-2 flex items-start">
                  <span className="text-mk-teal-500 mr-2">❓</span>
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed ml-7">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          {/* Ultra CTA Section */}
          <div className="bg-mk-teal-600 text-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl relative overflow-hidden mb-12">
            {/* Background Pattern */}
            <div className="absolute top-0 right-0 opacity-10 transform translate-x-1/4 -translate-y-1/4">
              <SafeIcon icon={FiCloud} className="w-64 h-64" />
            </div>
            
            <div className="relative z-10">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 mt-0">
                Schafswolle Dämmung in Heinsberg & NRW?
              </h2>
              <p className="text-mk-teal-100 text-lg mb-8 max-w-2xl leading-relaxed">
                Du planst eine Dämmung oder Sanierung? Wir prüfen Aufbau,Feuchtigkeit und Kosten – und sagen dir ehrlich,ob sich die Mehrkosten für Schafwolle bei deinem Projekt lohnen.
              </p>
              
              <div className="bg-white/10 rounded-xl p-6 mb-8 backdrop-blur-sm border border-white/20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center text-white">
                    <SafeIcon icon={FiCheckCircle} className="mr-2" />
                    <span>Kurzer Bau-Check vor Ort</span>
                  </div>
                  <div className="flex items-center text-white">
                    <SafeIcon icon={FiCheckCircle} className="mr-2" />
                    <span>Transparente Kosten-Einschätzung</span>
                  </div>
                  <div className="flex items-center text-white">
                    <SafeIcon icon={FiCheckCircle} className="mr-2" />
                    <span>Fachgerechte Ausführung (Heinsberg & NRW)</span>
                  </div>
                  <div className="flex items-center text-white">
                    <SafeIcon icon={FiCheckCircle} className="mr-2" />
                    <span>Auch Dach,Decke & Hohlwand</span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/kontakt" className="inline-flex items-center justify-center bg-white text-mk-teal-700 px-8 py-4 rounded-lg font-bold text-lg shadow-lg hover:bg-gray-100 transition-all transform hover:scale-105">
                  <SafeIcon icon={FiCloud} className="mr-2" />
                  Kostenlose Erstberatung anfragen
                </Link>
                <a href="tel:+4924528607038" className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/10 transition-colors">
                  <SafeIcon icon={FiPhone} className="mr-2" />
                  Direkt anrufen
                </a>
              </div>
              <p className="text-mk-teal-200 text-sm mt-6 mb-0">
                <strong>Tipp:</strong> Schreib kurz dazu,ob es um <strong>Dach</strong>,<strong>Innenwand</strong> oder <strong>Boden</strong> geht – dann bekommst du schneller eine konkrete Einschätzung.
              </p>
            </div>
          </div>

        </motion.article>
      </div>
      
      <RelatedTopics />
      <ServicesNavigationFooter />
      <GoogleMaps />
    </div>
  );
}

export default SheepWoolProsCons;